import { Box, EasyPopover, Icon, IconButton, styled, Typography } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { VoucherType } from "@tm/models"
import { TmaHelper } from "@tm/utils"
import { getCounterType } from "@bundles/vouchers/business"
import { VouchersFilter } from "../_shared/VouchersFilter"

type Props = {
    voucherType: VoucherType
    listActive: boolean
    onVoucherTypeChanged(voucherType: VoucherType): void
}

const StyledEasyPopoverContent = styled(EasyPopover.Content)(({ theme }) => ({
    border: `1px solid ${theme.palette.primary.main}`,
    padding: "8px",
}))

export function VoucherWidgetHeader(props: Props) {
    const { voucherType, listActive, onVoucherTypeChanged } = props
    const { translateText } = useLocalization()

    function getVoucherTypeByName() {
        if (voucherType === VoucherType.CostEstimation) {
            return translateText(82)
        }
        if (voucherType === VoucherType.Order) {
            return translateText(292)
        }
        if (voucherType === VoucherType.Return) {
            return translateText(13256)
        }
    }

    function handleChangeVoucherType(event: React.ChangeEvent<HTMLInputElement>) {
        const type = Number(event.target.value) as VoucherType
        TmaHelper.GeneralCountEvent.Call(getCounterType(type))
        onVoucherTypeChanged(type)
    }

    function renderFilters() {
        return (
            <EasyPopover anchorOrigin={{ vertical: "top", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "left" }}>
                <EasyPopover.ActionButton>
                    <IconButton noPadding>
                        <Icon name="pv-more" size="inherit" />
                    </IconButton>
                </EasyPopover.ActionButton>
                <StyledEasyPopoverContent>
                    <VouchersFilter onVoucherTypeChanged={handleChangeVoucherType} selectedVoucherType={voucherType} disabled={!listActive} />
                </StyledEasyPopoverContent>
            </EasyPopover>
        )
    }

    return (
        <Box display="flex" alignItems="center" gap="6px">
            <Typography variant="body2" color="inherit">
                {getVoucherTypeByName()}
            </Typography>
            {renderFilters()}
        </Box>
    )
}
